/**
 * Generates a UUID using crypto.randomUUID() with fallback for HTTP contexts.
 * crypto.randomUUID() is only available in secure contexts (HTTPS).
 * @returns {string} A UUID string
 */
const generateUUID = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for HTTP contexts (localhost/local network)
  // eslint-disable-next-line no-bitwise
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16);
    // eslint-disable-next-line no-bitwise
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export default generateUUID;
export { generateUUID };
